
"use client"

import * as yup from 'yup';
import Link from 'next/link';

import { useContext, useRef, useState } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from 'primereact/button';
import { Messages } from 'primereact/messages';
import { InputText } from 'primereact/inputtext';
import { InputCpfCnpj } from '@/components/InputCpfCnpj';

import { validCnpjCpf } from '@/libs/validations';
import { classNames } from 'primereact/utils';
import { AuthPortalContext } from '../../contexts/AuthPortalContext';
import { clearFormat } from '@/libs/utils/text';

const schema = yup.object({
  cpfCnpj: yup.string().required('Campo obrigatório!')
    .test('cpfCnpjValid', 'CPF/CNPJ não é valido!', (value, ctx) => {

      const valid = validCnpjCpf(value);

      return !valid ? ctx.createError() : valid;
    }),
  senha: yup.string().required("Campo obrigatório!")
}).required();

export type LoginInput = yup.InferType<typeof schema>;

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  
  // const { handleReCaptchaVerify } = useValidReCaptcha(); 
  const { signIn } = useContext(AuthPortalContext);
  const msgs = useRef<Messages>(null);

  const { control, handleSubmit, formState: { errors } } = useForm<LoginInput>({ resolver: yupResolver(schema) });

  const onSubmit: SubmitHandler<LoginInput> = async ({ cpfCnpj, senha }) => {
    try {
      msgs.current?.clear();
      setLoading(true);
      // const validCaptcha = await handleReCaptchaVerify()

      // if(validCaptcha){
        await signIn({ cpfCnpj: clearFormat(cpfCnpj), senha });
      // }

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      msgs.current?.show({
        sticky: true,
        severity: 'error',
        summary: error?.data.message
      });
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Messages ref={msgs} />
      <Controller
        name='cpfCnpj'
        control={control}
        render={({ field }) => (
          <div className={classNames('flex flex-column w-full mb-3', { 'p-error': errors.cpfCnpj })}>
            <span className={classNames('p-input-icon-left w-full', { 'p-error': errors.cpfCnpj })} >
              <i className="pi pi-user" />
              <InputCpfCnpj
                placeholder="CPF/CNPJ"
                className='p-inputtext p-component p-filled w-full'
                type='CPF_CNPJ'
                {...field}
              />
            </span>

            {errors.cpfCnpj && <div className="invalid-feedback">{errors.cpfCnpj?.message}</div>}
          </div>
        )}
      />

      <Controller
        name='senha'
        control={control}
        render={({ field }) => (
          <div className={classNames('flex flex-column w-full mb-3', { 'p-error': errors.senha })}>
            <span className="p-input-icon-left w-full mb-1">
              <i className="pi pi-lock" />
              <InputText
                placeholder="Senha"
                type='password'
                className='p-filled w-full'
                {...field}
              />
            </span>
            {errors.senha && <div className="invalid-feedback">{errors.senha?.message}</div>}
          </div>
        )}
      />
      <p className='text-right'>
        <Link href="recuperar-senha">Esqueceu a senha?</Link>
      </p>
      <Button label="Acessar"
        className="w-full text-xl"
        type='submit'
        loading={loading}>
      </Button>

      <hr />
      <p className="pt-5 text-600 text-center text-xl">
        Não tem conta? <Link href="/portal/solicitacao">Solicitar acesso</Link>
      </p>
    </form>
  );
}
